import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=7903b116&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7903b116')) {
      api.createRecord('7903b116', component.options)
    } else {
      api.reload('7903b116', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=7903b116&", function () {
      api.rerender('7903b116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xMo4i2KZhoUf/JS/comp/ImgFallback2.vue"
export default component.exports